import i18n from '@/i18n'

export function getTranslationOrUndefined (key: string | undefined): string | undefined {
    if (key && i18n.global.te(key)) {
        const translated = i18n.global.t(key)
        return translated && translated !== 'null' ? translated as string : undefined
    }
    return undefined
}
